
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AddPublicPage, UpdatePublicPage } from '@routes/publicpages/models/publicpage-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IPublicPageDetails, IPublicPages, IPublicPagesForDropdown } from './publicpage-model';

@Injectable()
export class PublicPagesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${PublicPagesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/publicpages';

    public getPublicPage(id: string): Observable<SuccessResponse<IPublicPageDetails> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IPublicPageDetails>>(PublicPagesService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getPublicPages(): Observable<SuccessResponse<IPublicPages> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IPublicPages>>(PublicPagesService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getPublicPagesForDropdown(): Observable<SuccessResponse<IPublicPagesForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IPublicPagesForDropdown>>(PublicPagesService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addPublicPage(publicPage: AddPublicPage): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(PublicPagesService.URL, publicPage).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updatePublicPage(publicPage: UpdatePublicPage): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(PublicPagesService.URL, publicPage).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deletePublicPage(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(PublicPagesService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public enablePublicPage(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(PublicPagesService.URL + '/enable', { id }).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public disablePublicPage(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(PublicPagesService.URL + '/disable', { id }).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
